import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AssetCreation from '../../Videos/RA-AssetCreation.mp4';
import Exposures from '../../Videos/RA-Exposures.mp4';
import PeerAnalyticsUniversesAndProforma from '../../Videos/RA-PeerAnalytics_UniversesAndProforma.mp4';
import AssetSettingsAndAttributes from '../../Videos/RA-AssetSettingsandAttributes.mp4';
import MarketDataAndIndices from '../../Videos/RA-MarketDataAndIndices.mp4';
import AssetReturnsAnalyticsandValuations from '../../Videos/RA-Asset Returns_AnalyticsandValuations.mp4';
import ResearchAnalyst from '../../Videos/ResearchAnalyst(RA).mp4';

export const HelpPage = () => {
  const location = useLocation();
  const sectionRefs = {
    Home: useRef(null),
    Asset: useRef(null),
    Portfolio: useRef(null),
    Investor: useRef(null),
  };

  const [activeVideo, setActiveVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get("section");

    if (section && sectionRefs[section]?.current) {
      const navbarHeight = document.querySelector("#SbaTopBar")?.offsetHeight || 0;
      const sectionTop = sectionRefs[section].current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: sectionTop - navbarHeight,
        behavior: "smooth",
      });
    }
  }, [location.search]);

  const videos = [
    {
      id: "Asset Creation",
      title: "Asset Creation",
      src: AssetCreation,
      type: "Asset"
    },
    {
      id: "Exposures",
      title: "Exposures",
      src: Exposures,
      type: "Asset"
    },
    {
      id: "PeerAnalyticsUniversesAndProforma",
      title: "Peer Analytics Universes And Proforma",
      src: PeerAnalyticsUniversesAndProforma,
      type: "Asset"
    },

    {
      id: "AssetSettingsAndAttributes",
      title: "Asset Settings and Attributes",
      src: AssetSettingsAndAttributes,
      type: "Asset"
    },
    {
      id: "AssetReturnsAnalyticsandValuations",
      title: "Asset Returns Analytics and Valuations",
      src: AssetReturnsAnalyticsandValuations,
      type: "Asset"
    },
    {
      id: "MarketDataAndIndices",
      title: "Market Data And Indices",
      src: MarketDataAndIndices,
      type: "Asset"
    }
    ,
    {
      id: "ResearchAnalyst",
      title: "Research Analyst",
      src: ResearchAnalyst,
      type: "UserRoles"
    }
  ];
  const openModal = (videoSrc) => {
    setActiveVideo(videoSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveVideo(null);
  };

  return (
    <div className="p-2 HelperWindow">
      <div ref={sectionRefs.Home} className="section Home">
        <h1>User Roles</h1>
        <div className="video-thumbnails-container p-3" style={{ overflowX: "auto", display: "flex", paddingBottom: "20px" }}>
          {videos.filter(item => item.type == "UserRoles").map((video) => (
            <div className="d-flex flex-column">
              <div
                key={video.id}
                className="video-thumbnail"
                onClick={() => openModal(video.src)}
                style={{
                  marginRight: "15px",
                  cursor: "pointer",
                  width: "120px",
                  height: "90px",
                  backgroundColor: "rgb(45, 71, 92)",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "center",
                  lineHeight: "1.2",
                  position: "relative",
                }}
              >

                <button
                  onClick={(e) => { e.stopPropagation(); openModal(video.src); }}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "50%",
                    padding: "10px",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#007bff",
                    fontWeight: "bold",
                    opacity: 0.5,
                  }}
                >
                  ▶
                </button>
              </div>
              <span className="text-center" style={{ width: "120px" }}>
                {video.title}
              </span>
            </div>
          ))}
        </div>

      </div>
      <div ref={sectionRefs.Asset} className="section Asset">
        <h1>Asset</h1>
        <div className="video-thumbnails-container p-3" style={{ overflowX: "auto", display: "flex", paddingBottom: "20px" }}>
          {videos.filter(item => item.type == 'Asset').map((video) => (
            <div className="d-flex flex-column">
              <div
                key={video.id}
                className="video-thumbnail"
                onClick={() => openModal(video.src)}
                style={{
                  marginRight: "15px",
                  cursor: "pointer",
                  width: "120px",
                  height: "90px",
                  backgroundColor: "rgb(45, 71, 92)",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "center",
                  lineHeight: "1.2",
                  position: "relative",
                }}
              >

                <button
                  onClick={(e) => { e.stopPropagation(); openModal(video.src); }}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "50%",
                    padding: "10px",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#007bff",
                    fontWeight: "bold",
                    opacity: 0.5,
                  }}
                >
                  ▶
                </button>
              </div>
              <span className="text-center" style={{ width: "120px" }}>
                {video.title}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div ref={sectionRefs.Portfolio} className="section Portfolio ">
        <h1>Portfolio</h1>
        <div className="video-thumbnails-container p-3" style={{ overflowX: "auto", display: "flex", paddingBottom: "20px" }}>
          {/* {videos.map((video) => (
            <div className="d-flex flex-column">
            <div
              key={video.id}
              className="video-thumbnail"
              onClick={() => openModal(video.src)}
              style={{
                marginRight: "15px",
                cursor: "pointer",
                width: "120px",
                height: "90px",
                backgroundColor: "rgb(45, 71, 92)",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: "1.2",
                position: "relative",
              }}
            >
            
              <button
                onClick={(e) => { e.stopPropagation(); openModal(video.src); }}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  border: "none",
                  borderRadius: "50%",
                  padding: "10px",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#007bff",
                  fontWeight: "bold",
                  opacity:0.5,
                }}
              >
                ▶
              </button>
            </div>
            <span className="text-center" style={{width: "120px"}}>
            {video.title}
            </span>
            </div>
          ))} */}

          <div className="d-flex flex-column">
            <div
              // key={video.id}
              // className="video-thumbnail"
              // onClick={() => openModal(video.src)}
              style={{
                marginRight: "15px",
                cursor: "pointer",
                width: "120px",
                height: "90px",
                backgroundColor: "rgb(45, 71, 92)",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: "1.2",
                position: "relative",
                paddingInline: "25px"
              }}
              className="h4"
            >
              Coming Soon..
            </div>
          </div>
        </div>
      </div>
      <div ref={sectionRefs.Investor} className="section Investor">
        <h1>Investor</h1>
        <div className="video-thumbnails-container p-3" style={{ overflowX: "auto", display: "flex", paddingBottom: "20px" }}>
          {/* {videos.filter(item => false).map((video) => (
            <div className="d-flex flex-column">
              <div
                key={video.id}
                className="video-thumbnail"
                onClick={() => openModal(video.src)}
                style={{
                  marginRight: "15px",
                  cursor: "pointer",
                  width: "120px",
                  height: "90px",
                  backgroundColor: "rgb(45, 71, 92)",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "center",
                  lineHeight: "1.2",
                  position: "relative",
                }}
              >

                <button
                  onClick={(e) => { e.stopPropagation(); openModal(video.src); }}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "50%",
                    padding: "10px",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#007bff",
                    fontWeight: "bold",
                    opacity: 0.5,
                  }}
                >
                  ▶
                </button>
              </div>
              <span className="text-center" style={{ width: "120px" }}>
                {video.title}
              </span>
            </div>
          ))} */}
              <div className="d-flex flex-column">
            <div
              // key={video.id}
              // className="video-thumbnail"
              // onClick={() => openModal(video.src)}
              style={{
                marginRight: "15px",
                cursor: "pointer",
                width: "120px",
                height: "90px",
                backgroundColor: "rgb(45, 71, 92)",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: "1.2",
                position: "relative",
                paddingInline: "25px"
              }}
              className="h4"
            >
              Coming Soon..
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="video-modal" style={modalStyles}>
          <div
            className="modal-overlay"
            onClick={closeModal}
            style={overlayStyles}
          ></div>
          <div className="modal-content">
            <video controls style={{ width: "100%", maxHeight: "80vh" }}>
              <source src={activeVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};


const modalStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  zIndex: 1000,
};

const overlayStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

const closeButtonStyles = {
  position: "absolute",
  top: "10px",
  right: "10px",
  backgroundColor: "transparent",
  color: "white",
  fontSize: "30px",
  border: "none",
  cursor: "pointer",
};
